import { Route, Routes, Navigate } from "react-router-dom";
import Login from "./Login";

function GuestRouter() {
  return (
    <Routes>
      <Route path="/" element={<Login />} />
      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  );
}

export default GuestRouter;